"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformDetector = void 0;
const types_1 = require("../types");
/**
 * Cross-platform detection utility
 * Determines the current runtime environment for Firebase configuration
 */
class PlatformDetector {
    static detect() {
        var _a;
        // Cache result to avoid repeated detection
        if (this.detectedPlatform) {
            return this.detectedPlatform;
        }
        // React Native detection
        if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
            this.detectedPlatform = types_1.Platform.ReactNative;
            return this.detectedPlatform;
        }
        // Web browser detection
        if (typeof window !== 'undefined' && typeof document !== 'undefined') {
            this.detectedPlatform = types_1.Platform.Web;
            return this.detectedPlatform;
        }
        // Node.js detection
        if (typeof process !== 'undefined' && ((_a = process.versions) === null || _a === void 0 ? void 0 : _a.node)) {
            this.detectedPlatform = types_1.Platform.Node;
            return this.detectedPlatform;
        }
        this.detectedPlatform = types_1.Platform.Unknown;
        return this.detectedPlatform;
    }
    static reset() {
        this.detectedPlatform = null;
    }
    static isWeb() {
        return this.detect() === types_1.Platform.Web;
    }
    static isMobile() {
        return this.detect() === types_1.Platform.ReactNative;
    }
    static isNode() {
        return this.detect() === types_1.Platform.Node;
    }
}
exports.PlatformDetector = PlatformDetector;
PlatformDetector.detectedPlatform = null;
